import { MapInformationService } from 'src/app/services/map-information.service';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { count, groupBy, mergeMap, takeUntil, toArray } from 'rxjs/operators';
import { SalesProjectService } from 'src/app/services/sales-project.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { GeneralService } from 'src/app/services/general.service';
import { ProjectService } from 'src/app/services/project.service';
import { TaskService } from 'src/app/services/task.service';
import CustomStore from 'devextreme/data/custom_store';
import { TranslateService } from '@ngx-translate/core';
import { ToastService } from 'ng-uikit-pro-standard';
import { Router } from '@angular/router';
import { from, Subject } from 'rxjs';
import { AppConfigService } from 'src/app/app-config.service.service';

@Component({
  selector: 'app-new-sales-lead',
  templateUrl: './new-sales-lead.component.html',
  styleUrls: ['./new-sales-lead.component.scss']
})

export class NewSalesLeadComponent implements OnInit {

  @Input() popupSalesLead = false;

  _formNewSales: FormGroup;
  optionsSalesPerson: any;
  salesPersonSelect = [];
  dateFormat: any;

  millisecondsInDay = 24 * 60 * 60 * 1000;
  todayButtondateex: any;
  prevDateButtondateex: any;
  nextDateButtondateex: any;
  dateex: number;

  private _unsubscribe = new Subject<void>();

  constructor(
    public MapInformationService:MapInformationService,
    private salesLeadsService: SalesProjectService,
    public appConfigService: AppConfigService,
    public generalService: GeneralService,
    private translate:TranslateService,
    private toast: ToastService,
    private router: Router,
  ) { 
    this.dateFormat = this.appConfigService.dateFormat;

    this.todayButtondateex = {
      text: this.translate.instant('btnToday'),
      elementAttr: {
        id: 'today-Btn'
      },
      onClick: () => {
          this.dateex = new Date().getTime();
      }
    };

    this.prevDateButtondateex = {
        icon: "spinprev",
        stylingMode: "text",
        onClick: () => {
          this.dateex -= this.millisecondsInDay;
        }
    };

    this.nextDateButtondateex = {
      icon: "spinnext",
      stylingMode: "text",
      onClick: () => {
        this.dateex += this.millisecondsInDay;
      }
    };
  }

  ngOnInit() {
    this.GetSalesPerson();
    this.optionsSalesPerson = [];

    this._formNewSales = new FormGroup({
      Name: new FormControl({ value: '', disabled: false }, [Validators.required, Validators.maxLength(50)]),
      Salesemp: new FormControl({ value: 1, disabled: false }, [Validators.required]),
      biddate: new FormControl({ value: "", disabled: false }, []),
    });
  }

  GetSalesPerson() {
    this.salesLeadsService.GetSalesPerson().pipe(takeUntil(this._unsubscribe)).subscribe(
      (data: any) => {
        this.optionsSalesPerson = data.map((val) => {
          return { // Return the new object structure
            label: val.CONTACTNAME,
            value: val.ID
          };
        });
      },
      err => {
        console.log(err);
      }
    )
  }

  clearFormNewSales() {
    this._formNewSales = new FormGroup({
      Name: new FormControl({ value: '', disabled: false }, [Validators.required, Validators.maxLength(50)]),
      Salesemp: new FormControl({ value: 1, disabled: false }, []),
      biddate: new FormControl({ value: "", disabled: false }, []),
    });
  }

  submitNewLeads(edit, newitem = false) {
    let formValue;
    formValue = this._formNewSales.value;
    formValue = { bidstatus: 1, ...formValue };

    formValue.method= "Insert_webLeads"
    formValue.name = formValue.Name
    formValue.salesemp = formValue.Salesemp
    formValue.id = 0
    formValue.biddate = new Date(formValue.biddate)

    delete formValue.Name
    delete formValue.Salesemp
    console.log(formValue)
    this.MapInformationService.SaveInfoSites(formValue).subscribe(
      data => {
        console.log(data)
        if (data[0].ReturnID) {
          this.toast.success(this.translate.instant('msgLeadCreSucc'));
          this.clearFormNewSales();
          // this.getSalesLeads()
          if (edit) {
            this.router.navigateByUrl('/salesLeads/editLead?numID=' + data[0].ReturnID);
          }
        } else {
          this.toast.error('Error Creating Sales Lead');
        }
        // this.getCustomer();
        $("#btnsaleslead").click();

        if (!newitem){
          $("#btnclosemodal").click();

          // this.get(true);
          this.popupSalesLead = false
        }
        // this.getSalesLeads()
      }, err => {
        console.log(err);
        this.toast.error('Error Creating Sales Lead');
      }
    )
  }

}
